module.exports = __webpack_public_path__ + "img/Engagement_Somewhat_Engaged_32.2e3f75d0.png";